import {
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
} from "react-icons/io5";
import { useState } from "react";
import DescriptionList from "./../../../../components/common/DescriptionList";
import Modal from "./../../../../components/common/Modal";
import IncomeForm from "./components/IncomeForm";

const IncomeInformation = ({ data, onRefresh }) => {
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const {
    annual_income,
    income_payor,
    professional_partnership,
    source_regular,
    source_contractual,
    source_clinic,
  } = data;

  const renderSources = (employee, contractual, clinic) => {
    const regular_employee = (
      <div className="border rounded-md text-xs text-gray-500 p-1 mr-1">
        Regular Employee
      </div>
    );

    const contractual_employee = (
      <div className="border rounded-md text-xs text-gray-500 p-1 mr-1">
        Contractual Employee
      </div>
    );

    const has_clinic = (
      <div className="border rounded-md text-xs text-gray-500 p-1 mr-1">
        Clinic
      </div>
    );

    return (
      <div className="flex mt-3">
        {employee && regular_employee}
        {contractual && contractual_employee}
        {clinic && has_clinic}
      </div>
    );
  };

  const renderIcon = (answer) => {
    let icon = <IoCheckmarkCircleOutline className="text-green-400 text-xl" />;
    if (!answer)
      icon = <IoCloseCircleOutline className="text-red-400 text-xl" />;

    return icon;
  };

  const handleSuccess = () => {
    setShowForm(false);
    onRefresh();
  };

  return (
    <>
      <div className="p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-500">Income Information</p>
            <span className="text-xs text-gray-400">Sources of Income</span>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <dl>
        <div className="bg-gray-50 px-6 py-5 grid grid-cols-3">
          <dt className="text-sm font-medium text-gray-400 col-span-2">
            Earning above 3M annually
          </dt>
          <dd className="col-span-1">
            <div className="float-right">{renderIcon(annual_income)}</div>
          </dd>
        </div>
        <div className="bg-white px-6 py-5 grid grid-cols-3">
          <dt className="text-sm font-medium text-gray-400 col-span-2">
            More than 1 income payor
          </dt>
          <dd className="col-span-1">
            <div className="float-right">{renderIcon(income_payor)}</div>
          </dd>
        </div>
        <div className="bg-gray-50 px-6 py-5 grid grid-cols-3">
          <dt className="text-sm font-medium text-gray-400 col-span-2">
            Partner with GPP
          </dt>
          <dd className="col-span-1">
            <div className="float-right">
              {renderIcon(professional_partnership)}
            </div>
          </dd>
        </div>
      </dl>
      <div className="grid grid-cols-2 p-5">
        <DescriptionList
          label="Sources of Income"
          className="col-span-2"
          content={renderSources(
            source_regular,
            source_contractual,
            source_clinic
          )}
        />
      </div>
      <Modal
        title="Income Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <IncomeForm
          data={data}
          isLoading={isFormLoading}
          setLoading={(value) => setIsFormLoading(value)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </>
  );
};

export default IncomeInformation;
